import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { GithubAccesses } from "./accesses.ts";
import { GithubComponents } from "./components.ts";

// Rule filter values compile to regular expressions, so a rule can say, e.g.,
// that `admin` on `acme/.*` needs approval. `role` is a repository role, and
// `team-role` a team role: patterns aren't anchored, so one filter for both
// would let a rule for `maintain` match `maintainer` too. `branch` is a
// branch's full name, `{org}/{repo}/{branch}`, so a rule for `main` names it
// as `.*/main$`.
const GithubFilters = {
  branch: { keys: ["name"] },
  organization: { keys: ["name"] },
  repository: { keys: ["name"] },
  role: { keys: ["name"], label: "Repository role" },
  team: { keys: ["name"] },
  "team-role": { keys: ["name"], label: "Team role" },
} as const satisfies AnyFilterSchema;
export type GithubFilters = typeof GithubFilters;

export const GithubRegistration = Registration({
  accesses: GithubAccesses,
  category: "resource",
  components: GithubComponents,
  docs: { install: "github", request: "github/requesting-access" },
  filters: GithubFilters,
  // The new item's form asks for the "Organization login".
  identifier: "login",
  itemKind: "Organization",
  label: "GitHub",
  logoUrl:
    "https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png",
  maturity: "beta",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "repository-access" }],
});

registerIntegration("github", GithubRegistration);
